// Authentication lives in the namespaced auth module and AuthService. Keeping
// the root action collection empty prevents accidental reintroduction of the
// legacy browser OAuth password grant.
export default {};
